<template lang="html">
  <div class="pkg-main" :class="[isActive, isTop, timeWordClass, isDelete]">
    <div class="time-word" v-if="timeWord">
      <div class="time-word-cell">
        <span>{{ timeWord }}</span>
      </div>
      <div class="time-word-shadow"></div>
    </div>
    <div class="pkg-box">
      <div class="pkg" :style="{fontWeight: weight}">
        <!-- <div class="pkg-img">
          <avatar
            v-if="imgUrl===''"
           :username="name"
           :size="32"
           color="#fff"
          >
          </avatar>
          <img :src="imgUrl" v-if="imgUrl!==''" alt="">
        </div> -->
        <div class="sender-name" @click="filesList(id, state);addActive()">
          <div class="name" :title="sender.name">
            {{sender.name}}
          </div>
        </div>
        <div class="pkg-name" @click="filesList(id, state);addActive()">
          <div class="name" :title="recipientsName">
            {{recipientsName}}
          </div>
          <div class="num" v-if="recipient.length>3&&recipientsName">
            {{recipient.length}}
          </div>
        </div>
        <div class="pkg-title" @click="filesList(id, state);addActive()">
            {{title}}
            <span class="notes" v-if="!deletion.is&&notesShow">- {{ notes }}</span>
            <span :title="expireInfo" class="notes waring" v-if="!deletion.is && expire.distance <= 2&& expire.time !=='-'">- {{ expireInfo }}</span>
          <span class="notes error" :title="deleteInfo" v-if="deletion.is">- {{ deleteInfo }}</span>
        </div>
        <div class="pkg-percent">
          <el-progress
            v-show = "percent !== 100"
            type="circle"
            :show-text = "false"
            :width="18" :percentage="percent" :stroke-width="3">
          </el-progress>
          <i class="el-icon-circle-check"
            style="font-size:18px;color:#20a0ff"
            v-show="percent === 100">
          </i>
        </div>
        <div v-show="fileNum === 1" class="pkg-size" :title="size">
          {{ fileNum }}{{message.Sl111.l0}}<span v-if="fileNum !== recordNum">({{recordNum}})</span> | {{ size }}
        </div>
        <div v-show="fileNum !== 1" class="pkg-size" :title="size">
          {{ fileNum }}{{message.Sl111.l1}}<span v-if="fileNum !== recordNum">({{recordNum}})</span> | {{ size }}
        </div>
        <div class="pkg-time" @click="filesList(id, state);addActive()">{{time}}</div>
        <div class="more" :style="{display: display}">
          <el-popover
            @hide="scheduleShow(false)"
            v-model="visibleF"
            ref="popover-c"
            placement="bottom"
            width="320"
            trigger="click">
            <div class="info-main">
              <div class="cell">
                <div class="name">
                  {{tableData[1].key}}:
                </div>
                <div class="value">
                  <span v-if="tableData[1].value === '-'">
                    N/A
                  </span>
                  <span v-if="tableData[1].value !== '-'">
                    {{tableData[1].value}}
                  </span>
                </div>
              </div>
              <div class="cell">
                <div class="name">
                  {{tableData[6].key}}:
                </div>
                <div class="value">
                  {{tableData[6].value}}
                </div>
              </div>
              <div class="cell" v-if="state === 'upload' && !this.disable">
                <!-- <div class="name">
                  {{}}
                </div> -->
                <div class="value">
                  {{message.Sl211}} ({{tableData[4].key}}: {{tableData[4].value}}):
                </div>
              </div>
              <div class="schedule" v-if="state === 'upload' && !this.disable">
                <comp-schedule
                  :id = "this.id"
                  :show= "this.visibleF&&this.state === 'upload'"
                ></comp-schedule>
              </div>
              <!-- <el-table
                :data="tableData"
                :show-header="false"
                border
                style="100%"
              >
                <el-table-column
                  prop="key"
                >
                </el-table-column>
                <el-table-column
                  prop="value"
                >
                </el-table-column>
              </el-table>
              <div class="check" v-if="state === 'upload'">
                <span @click="scheduleShow(true)">{{message.Sl210}}</span>
              </div>
            </div>
            <comp-schedule
              :id = "this.id"
              :show= "this.schedule"
              @scheduleBack="scheduleShow(false)"
            ></comp-schedule> -->
          </div>
          </el-popover>
          <span v-popover:popover-c class="material-icons icon info">
            info
          </span>
          <div class="info-box">
          </div>
        </div>
      </div>
      <div class="pkg-more">
        <div class="box-notes" :title="notes" v-show="notes !==''">
          {{message.Sl118}}：{{ notes }}
        </div>
        <div class="box-notes" :title="notes" v-show="notes ===''">
          {{message.Sl118}}：<em>{{message.Sl114}}</em>
        </div>
        <div class="fileList" v-loading="filesLoading">
          <comp-files
            v-for = "file in files"
            :key = "file.id"
            :id="file.id"
            :name="file.name"
            :size="file.size"
            :percent="file.percent"
            :fileState="file.state"
            :checkedList="checkedList"
            @cellChecked="checkedFiles"
            :isDelete="isDelete"
          >
          </comp-files>
        </div>
        <div class="page" v-show="total > 8">
          <el-pagination
            small
            layout="prev, pager, next"
            :page-size="8"
            :total="total"
            :current-page.sync="num"
            @current-change="pageList()"
            >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Avatar from 'vue-avatar'
import CompFiles from '@/components/box/pkg/file.vue'
import CompSchedule from '@/components/box/pkg/schedule.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    // Avatar,
    CompFiles,
    CompSchedule
  },
  computed: {
    ...mapGetters({
      app: 'app'
    }),
    'tableData': function () {
      if (this.type === 'receiver') {
        var percent = this.uploadPercent
      } else {
        percent = parseInt(this.percent)
      }
      var data = [
        {
          key: this.$lang.ui.system.pkgInfo.l00,
          value: this.time
        },
        {
          key: this.$lang.ui.system.pkgInfo.l01,
          value: this.expire.time
        },
        {
          key: this.$lang.ui.system.pkgInfo.l02,
          value: this.size
        },
        {
          key: this.$lang.ui.system.pkgInfo.l03,
          value: this.fileNum
        },
        {
          key: this.$lang.ui.system.pkgInfo.l04,
          value: this.downloadTimes
        },
        {
          key: this.$lang.ui.system.pkgInfo.l05,
          value: this.name
        },
        {
          key: this.$lang.ui.system.pkgInfo.l06,
          value: percent + '%'
        }
      ]
      return data
    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleA () {
      if (this.visibleA) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleD () {
      if (this.visibleD) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleF () {
      if (this.visibleF) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    deletion: function (val) {
      if (val.is) {
        this.isDelete = 'delete'
        this.deleteInfo = this.$lang.ui.notice.l125.l0 + val.name + this.$lang.ui.notice.l125.l1
      } else {
        this.isDelete = ''
        this.deleteInfo = ''
      }
    },
    'app.login': function (val) {
      if (val) {
        this.appActive = 'active'
      } else {
        this.appActive = ''
        this.dis.files = true
        this.dis.pkg = true
      }
    }
    // tableData: function (val) {
    //   if (this.state === 'upload' && this.tableData.length === 7) {
    //     this.tableData.splice(5, 1)
    //   }
    // }
  },
  props: [
    'type',
    'id',
    'sender',
    'recipient',
    'disable',
    'fileNum',
    'title',
    'time',
    'expire',
    'size',
    'notes',
    'weight',
    'percent',
    'state',
    'index',
    'timeWord',
    'deletion',
    'downloadTimes',
    'imgUrl',
    'uploadPercent',
    'isActive',
    'recordNum',
  ],
  data () {
    var uid = localStorage.getItem('uid')
    if (this.timeWord === '') {
      var timeWordClass = ''
    } else {
      timeWordClass = 'time'
    }
    if (this.index === 0) {
      var isTop = 'top'
    }
    if (this.deletion.is) {
      var isDelete = 'delete'
      var deleteInfo = ''
      if (this.deletion.type === 'expires') {
        deleteInfo = this.$lang.ui.notice.l121.l0 + this.deletion.time + this.$lang.ui.notice.l121.l1
        if (this.deletion.time <= 0) {
          deleteInfo = this.$lang.ui.notice.l121.l2
        }
      }
      if (this.deletion.type === 'after') {
        deleteInfo = this.$lang.ui.notice.l121.l0 + this.deletion.time + this.$lang.ui.notice.l121.l1
        if (this.deletion.time <= 0) {
          deleteInfo = this.$lang.ui.notice.l121.l2
        }
      }
      if (this.deletion.type === 'admin') {
        deleteInfo = this.$lang.ui.notice.l124.l0 + this.deletion.time + this.$lang.ui.notice.l124.l1
        if (this.deletion.time <= 0) {
          deleteInfo = this.$lang.ui.notice.l124.l2
        }
      }
      if (this.deletion.type === 'user') {
        if (this.deletion.id === uid) {
          deleteInfo = this.$lang.ui.notice.l122.l0 + this.deletion.time + this.$lang.ui.notice.l122.l1
          if (this.deletion.time <= 0) {
            deleteInfo = this.$lang.ui.notice.l122.l2
          }
        } else {
          if (this.state === 'download') {
            deleteInfo = this.$lang.ui.notice.l123.l0 + this.deletion.time + this.$lang.ui.notice.l123.l1
            if (this.deletion.time <= 0) {
              deleteInfo = this.$lang.ui.notice.l123.l2
            }
          } else {
            deleteInfo = this.$lang.ui.notice.l124.l0 + this.deletion.time + this.$lang.ui.notice.l124.l1
            if (this.deletion.time <= 0) {
              deleteInfo = this.$lang.ui.notice.l124.l2
            }
          }
        }
      }
      if (this.deletion.type === 'self') {
        // deleteInfo = this.$lang.ui.notice.l125
        deleteInfo = this.$lang.ui.notice.l125.l0 + this.deletion.name + this.$lang.ui.notice.l125.l1
      }
    } else {
      isDelete = ''
    }
    if (this.expire.time !== '-' && this.expire.distance <= 2) {
      var expireInfo = this.$lang.ui.notice.l126.l0 + this.expire.distance + this.$lang.ui.notice.l126.l1
      var notesShow = false
    } else {
      expireInfo = ''
      notesShow = true
    }
    let recipientsName = []
    let hasSelf = false
    let arrayNum = null
    this.recipient.map((value, key) => {
      if (uid === value.id) {
        hasSelf = true
        arrayNum = key
      }
      recipientsName.push(value.name)
    })
    if (this.state === 'upload') {
      recipientsName = recipientsName.join(',')
    } else {
      recipientsName = hasSelf ? recipientsName[arrayNum] : ''
    }
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Sl111: this.$lang.ui.system.l111,
        Sl112L1: this.$lang.ui.system.l112.l1,
        Sl112L2: this.$lang.ui.system.l112.l2,
        Sl113: this.$lang.ui.system.l113,
        Sl114: this.$lang.ui.system.l114,
        Sl115: this.$lang.ui.system.l115,
        Sl116: this.$lang.ui.system.l116,
        Sl117: this.$lang.ui.system.l117,
        Sl118: this.$lang.ui.system.l118,
        Sl207: this.$lang.ui.system.l207,
        Sl210: this.$lang.ui.system.l210,
        Al120: this.$lang.ui.app.l120,
        Sl211: this.$lang.ui.system.l211,
        Sl208: this.$lang.ui.system.l208
      },
      dis: {
        pkg: true,
        files: true
      },
      appActive: '',
      filesLoading: false,
      isTop: isTop,
      visibleA: false,
      visible: false,
      visibleB: false,
      visibleD: false,
      visibleE: false,
      visibleF: false,
      display: 'none',
      copyData: '111',
      files: [],
      num: 1,
      total: 0,
      checkedList: [],
      shareList: [],
      timeWordClass: timeWordClass,
      deleteInfo: deleteInfo,
      expireInfo: expireInfo,
      isDelete: isDelete,
      addUserList: [],
      addUserListOld: [],
      userList: [],
      notesShow: notesShow,
      tipWord: this.$lang.ui.system.l209,
      schedule: false,
      recipientsName: recipientsName,
    }
  },
  mounted () {
    // if (this.state !== 'download') {
    //   this.tableData.splice(5, 1)
    // }
    if (this.app.login) {
      this.appActive = 'active'
    } else {
      this.appActive = ''
      this.dis.files = true
      this.dis.pkg = true
    }
  },
  methods: {
    pageList () {
      this.filesList(this.id, this.state)
    },
    addActive () {
      this.checkedList = []
      this.$emit('removeActive')
      // if (this.isActive === '') {
      //   this.isActive = 'active'
      // } else {
      //   this.isActive = ''
      // }
    },
    filesList (id, state) {
      if (this.disable) {
        return
      }
      this.filesLoading = true
      this.files = []
      if (state === 'download') {
        var paramsData = {
          'op': state,
          'with_state': 1,
          'page_num': this.num,
          'page_size': 8,
          'no_dir_empty': 1,
        }
      } else {
        paramsData = {
          'op': state,
          'with_sender': 1,
          'with_state': 1,
          'page_num': this.num,
          'page_size': 8,
          'no_dir_empty': 1,
        }
      }
      this.$http.get('/cydex/api/v1/packages/' + id + '/files', { params: paramsData })
        .then(response => {
          this.files = []
          this.total = response.data.total_num
          if (state === 'upload') {
            var fileState = 'upload'
          } else {
            fileState = 'download'
          }
          for (var i = 0; i < response.data.files.length; i++) {
            let percent = 0
            if (response.data.files[i].size !== 0) {
              if (state === 'download') {
                percent = parseInt(response.data.files[i].state.finished_size / response.data.files[i].size * 100)
              } else {
                percent = parseInt(response.data.files[i].sender.finished_size / response.data.files[i].size * 100)
              }
            }
            this.files.push({
              id: response.data.files[i].id,
              name: response.data.files[i].name,
              size: this._global.trafficSwitch(response.data.files[i].size),
              percent: percent,
              state: fileState
            })
          }
          this.filesLoading = false
        })
    },
    checkedFiles (msg) {
      if (msg.checked) {
        this.checkedList.push({
          id: msg.id
        })
      } else {
        for (var i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === msg.id) {
            this.checkedList.splice(i, 1)
          }
        }
      }
    },
    getUserlist () {
      this.addUserList = []
      var id = localStorage.getItem('projectId')
      this.$http.get('/cydex/api/v1/projects/' + id + '/members', { params: {
        'sort': 'name'
      } })
        .then(response => {
          this.userList = []
          this.users = []
          this.addUserListOld = []
          for (var i = 0; i < response.data.members.length; i++) {
            if (response.data.members[i].user_info.is_black_user === 0) {
              this.userList.push({
                name: response.data.members[i].user_info.name,
                id: response.data.members[i].user_info.id
              })
            }
          }
          for (var x = 0; x < this.userIdList.length; x++) {
            this.addUserList.push(this.userIdList[x].id)
            this.addUserListOld.push(this.userIdList[x].id)
          }
        })
    },
    getSharelist () {
      var e = {
        package_id: this.id
      }
      this.$api.getSharelist(e, response => {
        this.shareList = []
        for (var i = 0; i < response.user_list.length; i++) {
          this.shareList.push({
            name: response.user_list[i].name,
            url: response.user_list[i].url_pkg_download,
            tip: false
          })
        }
      })
    },
    copyTip (e) {
      var index = parseInt(e.trigger.getAttribute('buttonIndex'))
      this.shareList[index].tip = true
      setTimeout(() => {
        this.shareList[index].tip = false
      }, 800)
    },
    addUser () {
      var removeList = []
      var addList = []
      for (var i = 0; i < this.addUserListOld.length; i++) {
        if (!this._global.arrayHas(this.addUserList, this.addUserListOld[i])) {
          removeList.push(this.addUserListOld[i])
        }
      }
      for (var a = 0; a < this.addUserList.length; a++) {
        if (!this._global.arrayHas(this.addUserListOld, this.addUserList[a])) {
          addList.push(this.addUserList[a])
        }
      }
      if (this.addUserList.length === 0) {
        return
      }
      this.$http.put('/cydex/api/v1/packages/' + this.id + '/recipients', {
        add_users: addList,
        remove_users: removeList
      })
        .then(() => {
          this.visibleD = false
          this.$emit('updateSuccess')
        })
    },
    scheduleShow (val) {
      this.schedule = val
    }
  }
}
</script>

<style scoped lang="css">
  .pkg-main {
    position: relative;
  }
  .time-word {
    position: relative;
    width: 100%;
    height: 50px;
  }
  .time-word-cell {
    position: absolute;
    z-index: 1;
    color: #616161;
    text-align: left;
    top: 0;
    left: -10px;
    right: -10px;
    bottom: 0px;
    background-color: #fff;
  }
  .time-word-cell span {
    position: absolute;
    bottom: 12px;
    left: 31px;
  }
  .pkg-main.active .time-word-cell span {
    left: 41px;
  }
  .time-word-shadow {
    z-index: 2;
    position: absolute;
    border-top: 1px solid #e5e5e5;
    left: 0px;
    right: 0px;
    height: 1px;
    bottom: 0px;
    background-color: #fff;
  }
  .pkg-main.active .time-word-shadow {
    display: none;
  }
  .pkg-main.time .pkg-box {
    background-color: #fff;
  }
  .top .time-word-cell {
    top: -5px;
    z-index: 2;
  }
  .pkg-main.active {
    height: 480px;
    margin-left: -10px;
    margin-right: -10px;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #fff;
  }
  .pkg-main.active.top {
    padding-top: 0;
    height: 450px;
  }
  .pkg-main.time.active {
    height: 530px;
  }
  .pkg-main.time.active.top {
    height: 500px;
  }
  .pkg-main.active .pkg-box {
    z-index: 3;
    position: relative;
    overflow: hidden;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  }
  .pkg {
    position: relative;
    z-index: 3;
    overflow: hidden;
    height: 50px;
    width: 100%;
    font-size: 15px;
    /* min-width: 620px; */
    line-height: 32px;
    background-color: #fff;
    cursor: pointer;
    color: #242729;
    text-align: left;
    padding: 9px 18px;
    border-bottom: 1px solid #e5e5e5;
  }
  .pkg-more {
    display: none;
    height: 0;
    background-color: #fff;
    overflow: hidden;
    transition: height 0.15s;
    width: 0px;
  }
  .fileList {
    position: relative;
    padding: 0 35px;
    height: 272px;
  }
  .pkg-main.active .pkg-more {
    display: block;
    position: relative;
    width: 100%;
    height: 370px;
    background-color: #fff;
  }
  .page {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 15px;
  }
  .box-notes {
    width: 100%;
    text-align: left;
    padding: 15px 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .pkg-img {
    position: relative;
    display: block;
    float: left;
    width: 32px;
    height: 32px;
    border-radius: 32px;
    overflow: hidden;
  }
  .pkg-img img {
    position: absolute;
    left: 0;
    top: 0;
    width: 32px;
    height: 32px;
  }
  .sender-name {
    float: left;
    display: flex;
    margin-left: 5px;
    width: 100px;
  }
  .pkg-name {
    float: left;
    display: flex;
    margin-left: 20px;
    width: 180px;
  }
  .name {
    float: left;
    flex-grow: 1;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .num {
    float: right;
    display: flex;
  }
  .pkg-title {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 330px;
    right: 380px;
    line-height: 48px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .pkg-time {
    color: #666;
    width: 140px;
    float: right;
  }
  .pkg-size {
    color: #666;
    float: right;
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .pkg-percent {
    margin: 7px 3px 7px 7px;
    width: 18px;
    height: 18px;
    float: right;
    line-height: 18px;
    text-align: center;
  }
  .notes {
    font-weight: 500;
    margin-left: 8px;
    color: #757575;
  }
  .notes.error {
    color: #d9534f;
    font-style: oblique;
  }
  .notes.waring {
    font-style: oblique;
    color: #f7ba2a;
  }
  .more {
    display: none;
    position: absolute;
    width: 220px;
    right: 0px;
    top: 9px;
    bottom: 9px;
    font-size: 19px;
    color: #666;
    background-color: #fff;
    line-height: 45px;
    padding-left: 15px;
  }
  .more .icon {
    padding: 0 10px;
  }
  .more .icon:hover {
    color: #242729;
  }
  .more .delete:hover {
    color: #d43f3a;
  }
  .pkg:hover .more {
    display: block !important;
  }
  .po-name {
    width: 100%;
    font-size: 14px;
    padding-left: 2px;
    color: #0291cf;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .check-files-list {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 50px;
    padding: 0 60px;
    line-height: 60px;
    top: 0;
    background-color: #fff;
  }
  .button-download {
    float: left;
    line-height: 0;
    cursor: pointer;
    border-radius: 4px;
    display: block;
    margin-top: 10px;
    margin-left: 20px;
    overflow: hidden;
    font-size: 14px;
    padding: 16px 20px;
    color: #fff;
    background-color: #d9534f;
    border: 1px solid #d43f3a;
  }
  .pkg-main.delete .pkg {
    opacity: 0.5;
  }
  .pkg-main.active.delete .pkg {
    opacity: 1;
  }
  .appDownload {
    opacity: 0.6;
  }
  .appDownload.active {
    opacity: 1;
  }
  .share-cell {
    position: relative;
    padding: 5px 0;
  }
  .tip {
    position: absolute;
    z-index: 1;
    width: 70px;
    height: 30px;
    bottom: 5px;
    right: 0;
  }
  .check {
    padding: 12px 0;
    border: 1px solid #e6ebf5;
    border-top: 0px;
    text-align: center;
  }
  .check span {
    cursor: pointer;
    color: #007bc5;
  }
  .check span:hover {
    font-weight: 600;
  }
  .info-main {
    max-height: 338px;
  }
  .info-main .cell {
    padding: 8px 5px;
  }
  .info-main .cell .name {
    width: 180px;
  }
  .schedule {
    position: relative;
    width: 95%;
    height: 80px;
  }
</style>
